import { DialogTemplate } from "src/app/_models/body"
import { InputFieldType } from "src/app/common/constants"

export const VirtualMallTemplate = (assetCategory: Array<any>, mmitaReward: Array<any>, aiBuddyAsset: Array<any>): DialogTemplate => {
    return {
        dialogTitle: 'Set Virtual Mall',
        dialogFields: [
            {
                key: 'description',
                label: 'Description',
                type: InputFieldType.Text,
                size: 24,

            },
            {
                key: 'settingJsonUrl',
                label: 'Setting Json Url',
                type: InputFieldType.Uploader,
                size: 12,
                required: true,

            },
            {
                key: 'productJsonUrl',
                label: 'Product Json Url',
                type: InputFieldType.Uploader,
                size: 12,
                required: true,
            },
            {
                key: 'assetCategoryId',
                label: 'Asset Category Id',
                type: InputFieldType.Selector,
                options: assetCategory,
                size: 12,
                required: true,
                isClearDisabled: true,
            },
            {
                key: 'aiBuddyAssetId',
                label: 'AI Buddy Asset Id',
                type: InputFieldType.Selector,
                options: aiBuddyAsset,
                size: 12,
                required: true,
                isClearDisabled: true,
            },
            {
                key: 'mmitaRewardIds',
                label: 'Reward Ids',
                type: InputFieldType.Selector,
                options: mmitaReward,
                mode: 'multiple',
                size: 24,
                selectorLabel: 'description'
            },
        ]
    }
}